import styled, { css } from 'styled-components'
import { pageCenter } from 'styles/page-center.styles'

export const CoachPageWrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  margin-bottom: -50px;
`

export const HeroSection = styled.div`
  width: 100%;
  height: 60vh; /* 76% of viewport height */
  max-height: 600px; /* cap the maximum height */
  min-height: 300px; /* ensure minimum height for smaller screens */
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.palette.primary.main} 0%,
    ${({ theme }) => theme.palette.primary.light} 100%
  );
  position: relative;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;

  /* Create padding that doesn't affect centering */
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px; /* Height for CTA overlap */
    z-index: 0;
  }

  ${({ theme }) => css`
    ${theme.breakpoints.down.md} {
      &::after {
        height: 60px;
      }
    }

    ${theme.breakpoints.down.sm} {
      &::after {
        height: 40px;
      }
    }
  `}

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
  }
`

export const HeroContent = styled.div`
  ${pageCenter};
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 2rem;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 100px;
  transform: translateY(-40px); /* Shift up slightly to compensate for the bottom spacing */

  ${({ theme }) => css`
    ${theme.breakpoints.down.md} {
      transform: translateY(20px);
    }

    ${theme.breakpoints.down.sm} {
      padding: 1rem;
      transform: translateY(20px);
    }
  `}

  h1 {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
    color: white;

    ${({ theme }) => css`
      ${theme.breakpoints.down.sm} {
        font-size: 1.8rem;
        margin-bottom: 1rem;
      }
    `}
  }

  p {
    font-size: 1.2rem;
    max-width: 800px;
    margin: 0 auto;

    ${({ theme }) => css`
      ${theme.breakpoints.down.sm} {
        font-size: 1rem;
      }
    `}
  }
`

export const CtaContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.background.default};
  border-radius: 12px;
  padding: 2rem;
  max-width: 600px;
  margin: -80px auto 2rem;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
  text-align: center;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ theme }) => css`
    ${theme.breakpoints.down.md} {
      margin-top: -60px;
      padding: 1.5rem;
    }

    ${theme.breakpoints.down.sm} {
      margin-top: -40px;
      padding: 1.25rem;
    }
  `}

  p {
    margin-bottom: 1.5rem;
    font-size: 1.1rem;
    width: 100%;
  }

  /* Ensure the CtaLesson button is properly centered */
  & > div {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  /* Apply specific styling to CtaLesson button */
  a,
  button {
    display: inline-flex;
    justify-content: center;
    min-width: 200px;
  }
`

export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin: 3rem 0;

  ${({ theme }) => css`
    ${theme.breakpoints.down.md} {
      grid-template-columns: 1fr;
    }
  `}
`

export const FeatureCard = styled.div`
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: 8px;
  padding: 1.5rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }

  h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.palette.text.primary};
    display: flex;
    align-items: center;

    svg {
      margin-right: 0.75rem;
    }
  }

  p {
    flex-grow: 1;
    margin: 0;
  }
`

export const ContentContainer = styled.div`
  ${pageCenter};
  padding: 1rem;
`

export const FooterCta = styled.div`
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: 3rem 1rem;
  text-align: center;
  margin-top: 3rem;
  border-radius: 8px;

  p {
    font-size: 1.25rem;
    max-width: 800px;
    margin: 0 auto 2rem;
    font-weight: 500;
  }
`
